import { useState } from 'react';
import { useHydrateAtoms } from 'jotai/utils';
import { BackButton } from '@/components';
import { SelectChildDto } from '@/shared/interfaces';
import { R } from '@/Resources.resx';
import {
    adolescentMinimumAgeAtom,
    adultMinimumAgeAtom,
    isAdolescentEnabledAtom,
} from '@/caregiverSpace/shared/model';
import { PfaPhysiotherapyAppProps } from '@/features/pfaPhysiotherapy/app/PfaPhysiotherapyApp';
import {
    PfaPhysioStep,
    usePfaPhysiotherapyFlow,
} from '@/features/pfaPhysiotherapy/model/usePfaPhysiotherapyFlow';
import { LandingPage } from '@/features/pfaPhysiotherapy/widgets/landing-page/LandingPage';
import { SelectPfaPatient } from '@/features/pfaPhysiotherapy/widgets/select-patient/SelectPfaPatient';
import { Consent } from '@/features/pfaPhysiotherapy/widgets/consent/Consent';

export const PfaPhysiotherapyFlow = ({
    appProps,
}: {
    appProps: PfaPhysiotherapyAppProps;
}) => {
    useHydrateAtoms([
        [adolescentMinimumAgeAtom, appProps.adolescentMinAge],
        [adultMinimumAgeAtom, appProps.adultMinAge],
        [isAdolescentEnabledAtom, appProps.isAdolescentEnabled],
    ]);

    const [children, setChildren] = useState<SelectChildDto[]>(
        appProps.children,
    );

    const {
        currentPage,
        navigateBack,
        onLandingNext,
        onSelectPatient,
        onAcceptConsent,
    } = usePfaPhysiotherapyFlow({ appProps: appProps });

    return (
        <div className="max-w-narrow mx-auto mt-14 mb-4">
            {currentPage !== PfaPhysioStep.Landing && (
                <BackButton
                    onClick={navigateBack}
                    className="mb-4"
                    text={R.Back}
                />
            )}

            {currentPage === PfaPhysioStep.Landing && (
                <LandingPage onNext={onLandingNext} />
            )}

            {currentPage === PfaPhysioStep.SelectPatient && (
                <SelectPfaPatient
                    onSelectPatient={onSelectPatient}
                    parentUid={appProps.parentUid}
                    parentFirstName={appProps.parentFirstName}
                    parentGender={appProps.parentGender}
                    children={children}
                    setChildren={setChildren}
                />
            )}

            {currentPage === PfaPhysioStep.Consent && (
                <Consent onAccept={onAcceptConsent} />
            )}
        </div>
    );
};
